<template>
    <s-v-g-icon :width="width" :height="height" view-box="0 0 512 512">
        <g>
            <path d="M344.556,112.216C318.38,78.84,291.34,44.344,269.516,7.32c-5.76-9.76-21.824-9.76-27.552,0
			c-21.856,37.024-48.896,71.52-75.072,104.896c-53.056,67.68-103.168,131.616-103.168,207.232c0,105.888,86.112,192,192,192
			s192-86.112,192-192C447.724,243.832,397.612,179.896,344.556,112.216z"/>
        </g>
    </s-v-g-icon>
</template>

<script>
    import SVGIcon from "../../../components/SVGIcon";
    export default {
        name: "ImpressionsIcon",
        components: {SVGIcon},
        props:{
            width: {
                type: [Number, String],
                default: 32
            },
            height: {
                type: [Number, String],
                default: 32
            },
            color: {
                type: String,
                default: 'currentColor'
            },
        }
    }
</script>

<style scoped>

</style>
